import { useEasyProvider } from '@shared/components/EasyProvider'

import Fab from '@mui/material/Fab'
import AddIcon from '@mui/icons-material/Add'

export default function Add() {
    const {
        setFormVisibility,
        setInstance
    } = useEasyProvider()

    return (
        <Fab
            variant='extended'
            color='primary'
            sx={{
                position: 'fixed',
                bottom: 15,
                insetInlineEnd: 15,
                fontSize: 15,
                gap: 1
            }}
            onClick={() => {
                setInstance(null)
                setFormVisibility(true)
            }}
        >
            إضافة مكتب
            <AddIcon />
        </Fab>
    )
}